import React from "react";
import { isEmpty } from "lodash";
import { NumberInput, Panel, SelectInput, UnitInput } from "../input";
import GrigoraCSSRenderer from "./../blocks/css-render";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { isUpdatedFromDefault } from "../utils";
import { INPUT_LIMITS } from "../input-limits";

function Position({ block, actions, ...props }) {
  const {
    id,
    props: { blockPosition = {} },
    dom,
  } = block;
  const { setProp } = actions;

  return (
    <>
      <Panel
        isUpdated={isUpdatedFromDefault([{ key: blockPosition, default: {} }])}
        id={`block-setting-${id}-position`}
        title={"Position"}
        initialOpen={false}
      >
        {!(blockPosition && isEmpty(blockPosition)) && (
          <>
            <div className="flex text-xs justify-between mb-2">
              Reset Position
              <div
                onClick={() => {
                  setProp((props) => {
                    props.blockPosition = undefined;
                  });
                }}
                className="mr-2 cursor-pointer"
              >
                <FontAwesomeIcon icon={faRefresh} size="sm" />
              </div>
            </div>
          </>
        )}
        <SelectInput
          isResetVisible={false}
          isResponsive={true}
          value={blockPosition?.desktop?.position}
          valueTablet={blockPosition?.tablet?.position}
          valueMobile={blockPosition?.mobile?.position}
          onChange={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                desktop: {
                  ...props.blockPosition?.desktop,
                  position: val,
                },
              };
            });
          }}
          setValueTablet={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                tablet: {
                  ...props.blockPosition?.tablet,
                  position: val,
                },
              };
            });
          }}
          setValueMobile={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                mobile: {
                  ...props.blockPosition?.mobile,
                  position: val,
                },
              };
            });
          }}
          options={[
            {
              label: "Default",
              value: "",
            },
            {
              label: "Relative",
              value: "relative",
            },
            {
              label: "Absolute",
              value: "absolute",
            },
            {
              label: "Sticky",
              value: "sticky",
            },
            {
              label: "Fixed",
              value: "fixed",
            },
            {
              label: "Static",
              value: "static",
            },
          ]}
          label="Position"
        />
        <NumberInput
          max={INPUT_LIMITS["position-support-zindex"].max}
          min={INPUT_LIMITS["position-support-zindex"].min}
          step={INPUT_LIMITS["position-support-zindex"].step}
          isResetVisible={false}
          isResponsive={true}
          value={blockPosition?.desktop?.zIndex}
          valueTablet={blockPosition?.tablet?.zIndex}
          valueMobile={blockPosition?.mobile?.zIndex}
          onChange={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                desktop: {
                  ...props.blockPosition?.desktop,
                  zIndex: val,
                },
              };
            });
          }}
          setValueTablet={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                tablet: {
                  ...props.blockPosition?.tablet,
                  zIndex: val,
                },
              };
            });
          }}
          setValueMobile={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                mobile: {
                  ...props.blockPosition?.mobile,
                  zIndex: val,
                },
              };
            });
          }}
          label={"Z Index"}
        />
        <UnitInput
          isNegativeValid={true}
          isResetVisible={false}
          isResponsive={true}
          value={blockPosition?.desktop?.left}
          valueTablet={blockPosition?.tablet?.left}
          valueMobile={blockPosition?.mobile?.left}
          onChange={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                desktop: {
                  ...props.blockPosition?.desktop,
                  left: val,
                },
              };
            });
          }}
          setValueTablet={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                tablet: {
                  ...props.blockPosition?.tablet,
                  left: val,
                },
              };
            });
          }}
          setValueMobile={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                mobile: {
                  ...props.blockPosition?.mobile,
                  left: val,
                },
              };
            });
          }}
          label={"Left"}
        />
        <UnitInput
          isNegativeValid={true}
          isResetVisible={false}
          isResponsive={true}
          value={blockPosition?.desktop?.right}
          valueTablet={blockPosition?.tablet?.right}
          valueMobile={blockPosition?.mobile?.right}
          onChange={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                desktop: {
                  ...props.blockPosition?.desktop,
                  right: val,
                },
              };
            });
          }}
          setValueTablet={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                tablet: {
                  ...props.blockPosition?.tablet,
                  right: val,
                },
              };
            });
          }}
          setValueMobile={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                mobile: {
                  ...props.blockPosition?.mobile,
                  right: val,
                },
              };
            });
          }}
          label={"Right"}
        />
        <UnitInput
          isNegativeValid={true}
          isResetVisible={false}
          isResponsive={true}
          value={blockPosition?.desktop?.top}
          valueTablet={blockPosition?.tablet?.top}
          valueMobile={blockPosition?.mobile?.top}
          onChange={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                desktop: {
                  ...props.blockPosition?.desktop,
                  top: val,
                },
              };
            });
          }}
          setValueTablet={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                tablet: {
                  ...props.blockPosition?.tablet,
                  top: val,
                },
              };
            });
          }}
          setValueMobile={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                mobile: {
                  ...props.blockPosition?.mobile,
                  top: val,
                },
              };
            });
          }}
          label={"Top"}
        />
        <UnitInput
          isNegativeValid={true}
          isResetVisible={false}
          isResponsive={true}
          value={blockPosition?.desktop?.bottom}
          valueTablet={blockPosition?.tablet?.bottom}
          valueMobile={blockPosition?.mobile?.bottom}
          onChange={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                desktop: {
                  ...props.blockPosition?.desktop,
                  bottom: val,
                },
              };
            });
          }}
          setValueTablet={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                tablet: {
                  ...props.blockPosition?.tablet,
                  bottom: val,
                },
              };
            });
          }}
          setValueMobile={(val) => {
            setProp((props) => {
              props.blockPosition = {
                ...props.blockPosition,
                mobile: {
                  ...props.blockPosition?.mobile,
                  bottom: val,
                },
              };
            });
          }}
          label={"Bottom"}
        />
      </Panel>
    </>
  );
}

function transformProps(props, supportProps) {
  const { id, blockPosition } = props;
  if (
    blockPosition?.desktop?.position ||
    blockPosition?.tablet?.position ||
    blockPosition?.mobile?.position ||
    blockPosition?.desktop?.zIndex ||
    blockPosition?.tablet?.zIndex ||
    blockPosition?.mobile?.zIndex ||
    blockPosition?.desktop?.left ||
    blockPosition?.tablet?.left ||
    blockPosition?.mobile?.left ||
    blockPosition?.desktop?.right ||
    blockPosition?.tablet?.right ||
    blockPosition?.mobile?.right ||
    blockPosition?.desktop?.top ||
    blockPosition?.tablet?.top ||
    blockPosition?.mobile?.top ||
    blockPosition?.desktop?.bottom ||
    blockPosition?.tablet?.bottom ||
    blockPosition?.mobile?.bottom
  ) {
    supportProps = {
      ...supportProps,
      className: {
        ...(supportProps.className ? supportProps.className : {}),
        [`position-${id}`]: true,
      },
    };
  }
  return supportProps;
}

function dynamicCSS(id, props) {
  const { blockPosition } = props;
  if (
    blockPosition?.desktop?.position ||
    blockPosition?.tablet?.position ||
    blockPosition?.mobile?.position ||
    blockPosition?.desktop?.zIndex ||
    blockPosition?.tablet?.zIndex ||
    blockPosition?.mobile?.zIndex ||
    blockPosition?.desktop?.left ||
    blockPosition?.tablet?.left ||
    blockPosition?.mobile?.left ||
    blockPosition?.desktop?.right ||
    blockPosition?.tablet?.right ||
    blockPosition?.mobile?.right ||
    blockPosition?.desktop?.top ||
    blockPosition?.tablet?.top ||
    blockPosition?.mobile?.top ||
    blockPosition?.desktop?.bottom ||
    blockPosition?.tablet?.bottom ||
    blockPosition?.mobile?.bottom
  ) {
    return `
            .position-${id}{
                ${GrigoraCSSRenderer.position(blockPosition?.desktop?.position)}
                ${GrigoraCSSRenderer.zindex(blockPosition?.desktop?.zIndex)}
                ${GrigoraCSSRenderer.left(blockPosition?.desktop?.left)}
                ${GrigoraCSSRenderer.right(blockPosition?.desktop?.right)}
                ${GrigoraCSSRenderer.top(blockPosition?.desktop?.top)}
                ${GrigoraCSSRenderer.bottom(blockPosition?.desktop?.bottom)}
            }

            /* Tablet */
            @media (min-width: 768px) and (max-width: 1024px) {
              .position-${id}{
                ${GrigoraCSSRenderer.position(blockPosition?.tablet?.position)}
                ${GrigoraCSSRenderer.zindex(blockPosition?.tablet?.zIndex)}
                ${GrigoraCSSRenderer.left(blockPosition?.tablet?.left)}
                ${GrigoraCSSRenderer.right(blockPosition?.tablet?.right)}
                ${GrigoraCSSRenderer.top(blockPosition?.tablet?.top)}
                ${GrigoraCSSRenderer.bottom(blockPosition?.tablet?.bottom)}
              }
            }
        
            /* Mobile */
            @media (max-width: 767px) {
              .position-${id}{
                ${GrigoraCSSRenderer.position(blockPosition?.mobile?.position)}
                ${GrigoraCSSRenderer.zindex(blockPosition?.mobile?.zIndex)}
                ${GrigoraCSSRenderer.left(blockPosition?.mobile?.left)}
                ${GrigoraCSSRenderer.right(blockPosition?.mobile?.right)}
                ${GrigoraCSSRenderer.top(blockPosition?.mobile?.top)}
                ${GrigoraCSSRenderer.bottom(blockPosition?.mobile?.bottom)}
              }
            }
        `;
  }
  return "";
}

const supportSchema = {
  id: "grigora/position",
  name: "Position",
  component: Position,
  transformProps: transformProps,
  dynamicCSS: dynamicCSS,
};

export default supportSchema;
